import React from "react";
import type { EdgeData, NodePosition } from "./types";

interface MindMapEdgesProps {
  edges: EdgeData[];
  positions: Record<string, NodePosition>;
}

export const MindMapEdges: React.FC<MindMapEdgesProps> = ({ edges, positions }) => {
  return (
    <svg
      className="pointer-events-none absolute inset-0 h-full w-full"
      style={{ overflow: "visible" }}
    >
      <defs>
        {edges.map((edge) => {
          const fromPos = positions[edge.from];
          const toPos = positions[edge.to];
          if (!fromPos || !toPos) return null;

          const x1 = fromPos.right.x;
          const y1 = fromPos.right.y;
          const x2 = toPos.left.x;
          const y2 = toPos.left.y;

          return (
            <linearGradient
              key={`grad-${edge.id}`}
              id={`edge-grad-${edge.id}`}
              gradientUnits="userSpaceOnUse"
              x1={x1}
              y1={y1}
              x2={x2}
              y2={y2}
            >
              <stop offset="0%" stopColor="rgba(103, 58, 183, 0.9)" />
              <stop offset="100%" stopColor="rgba(33, 150, 243, 0.9)" />
            </linearGradient>
          );
        })}
      </defs>
      {edges.map((edge) => {
        const fromPos = positions[edge.from];
        const toPos = positions[edge.to];
        if (!fromPos || !toPos) return null;

        const x1 = fromPos.right.x;
        const y1 = fromPos.right.y;
        const x2 = toPos.left.x;
        const y2 = toPos.left.y;

        const dx = Math.abs(x2 - x1) * 0.5;
        const path = `M ${x1} ${y1} C ${x1 + dx} ${y1}, ${x2 - dx} ${y2}, ${x2} ${y2}`;

        return (
          <g key={edge.id}>
            <path
              d={path}
              fill="none"
              stroke="rgba(103, 58, 183, 0.2)"
              strokeWidth={4}
              strokeLinecap="round"
            />
            <path
              d={path}
              fill="none"
              stroke={`url(#edge-grad-${edge.id})`}
              strokeWidth={1.5}
              strokeLinecap="round"
            />
          </g>
        );
      })}
    </svg>
  );
};
